import { AuthData } from '../../infra/repositories/ApiAuthRepository';
import { IAuthRepository } from '../ports/outbound/IAuthRepository';
import { AccountListItem } from '../domain/entities/accountListItem';
import Account from '@/features/account/application/domain/entities/account';

export class AuthUseCase {
  constructor(private repo: IAuthRepository) {}
  async execute(): Promise<void> {}

  async logout(): Promise<void> {
    return this.repo.logout();
  }

  /** Re-derive the signed-in user from the browser's session cookie. Rejects 401 when signed out. */
  async getSession(): Promise<AuthData> {
    return this.repo.getSession();
  }

  async exchangeGrantToken(grantCode: string): Promise<AuthData> {
    return this.repo.exchangeGrantToken(grantCode);
  }

  async getAccountList(): Promise<AccountListItem[]> {
    return this.repo.getAccountList();
  }

  async selectAccount(accountId: string): Promise<Account | null> {
    return this.repo.selectAccount(accountId);
  }
}
